import { postData } from "../api/fetch";
import { showResultModal } from "../components/lottieModal";

export default function formSubmit(formData) {
  // 1. loading
  showResultModal("loading", "Отправляем заявку...");

  // postData(window.ajax_url, formData)
  // postData(window.domain_url, formData)
  postData('/api/sendform/', formData)
    .then((response) => {
      // console.log(response);

      // 2. success
      showResultModal("success", "Заявка успешно отправлена!");
      const btnEl = document.getElementById("modal-submit");
      if (btnEl && btnEl.hasAttribute("car_id")) {
        btnEl.removeAttribute("car_id");
        btnEl.removeAttribute("going");
      }

      // 3. Отправка цели в Яндекс Метрику
      if (typeof ym !== "undefined") {
        ym(108536876, "reachGoal", "order");
        // console.log('Цель "order" отправлена в Яндекс Метрику');
      } else {
        console.warn("Яндекс Метрика не найдена");
      }
    })
    .catch((error) => {
      console.error("Ошибка:", error);

      // 3. error
      showResultModal("error", "Произошла ошибка. Попробуйте позже.");
    });
}
